import { createContext } from "react";
export const WorldContext = createContext(null);
